const parseLocalStorage = (item: string) => {
  const stored = localStorage.getItem(item);
  try {
    return JSON.parse(stored || '');
  } catch (e) {
    return null;
  }
};

export default parseLocalStorage;
